import { Outlet, useParams } from "react-router-dom";
import PostsPage from "../../../modules/post/PostsPage";

const Tab4 = ({ routeBase = "/customer/posts", mode }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PostsPage routeBase={routeBase} mode={mode} />;
};

export default Tab4;
